<div class="actionbar">
  <button mat-button (click)="clickInvoices()">Rechnungen Anzeigen</button>
  <button mat-button [matMenuTriggerFor]="actionsMenu">Actions</button>
  <mat-menu #actionsMenu="matMenu">
    <button
      mat-menu-item
      (click)="clickSkipInvoiceNumber()"
      [disabled]="skippingNumber"
    >
      Skip invoice number
    </button>
    <button
      mat-menu-item
      (click)="clickCreateExternalInvoice()"
      [disabled]="creatingExternalInvoice"
    >
      Create external invoice
    </button>
  </mat-menu>
</div>
<input placeholder="Suche" [formControl]="searchControl" />
<ag-grid-angular
  style="width: 100%; height: 100%"
  class="ag-theme-alpine"
  [getRowId]="getRowId"
  [pagination]="true"
  [paginationAutoPageSize]="true"
  [rowSelection]="'multiple'"
  [columnDefs]="columnDefs"
  [defaultColDef]="defaultColDef"
  (cellClicked)="onCellClicked($event)"
  (gridReady)="onGridReady($event)"
>
</ag-grid-angular>

<div
  class="modal-overlay"
  *ngIf="showSkipNumberModal"
  (click)="closeSkipNumberModal()"
>
  <div class="modal-card" (click)="$event.stopPropagation()">
    <h3>Invoice number skipped</h3>
    <p>{{ skippedInvoiceNumber }}</p>
    <button mat-raised-button color="primary" (click)="closeSkipNumberModal()">
      Close
    </button>
  </div>
</div>
